import color from '@mui/material/colors/green';
export default function Style(theme) {

    const style = {
        formControl: {
          margin: 0,
          minWidth: 120,
        },
        selectEmpty: {
          marginTop: 8,
        },
        quantityInput: {
            margin: 8
        },
          margin: {
            margin: 8
          },
          withoutLabel: {
            marginTop: 24,
          },
          textField: {
            width: '',
          },
          rootAddress: {
            minWidth: 350
          },
          img: {
            maxWidth: 150,
            maxHeight: 150
          },
          imgContainer: {
            border:"2px solid "+color[500],
            borderRadius: 10,
            margin: 5
          }
      }
    return style
}